import type { useErrorFallbackModel } from '@/components/shared/error-fallback/error-fallback.model'

type ErrorFallbackViewProps = ReturnType<typeof useErrorFallbackModel>

export function ErrorFallbackView({
  headline,
  message,
  homeHref,
  homeLabel,
}: ErrorFallbackViewProps) {
  return (
    <div className="fz-error-fallback">
      <div className="fz-error-fallback__content">
        <h1 className="fz-error-fallback__headline">{headline}</h1>
        <p className="fz-error-fallback__message">{message}</p>
        <a href={homeHref} className="fz-error-fallback__link">
          {homeLabel}
        </a>
      </div>
    </div>
  )
}
